import parse from 'html-react-parser';
import Icons from '../../../components/layout/icons/Icons';
import { IconColors, PilotageExemptionApplicationStatusColors, PilotageExemptionApplicationStatusEnum } from '../../../services/SystemNames';
import Spacer from '../../../components/layout/Spacer';
import SvgIcon from '../../../components/layout/icons/Icons';
import { isArrayEmpty, isObjectNull } from '../../../components/helpers/ObjectHelpers';
import {
    createPilotAssignmentPilotsShortList,
    isPilotAssignmentAssignedAndNotProcessed,
    isPilotAssignmentCompleted,
    isPilotAssignmentCorrectionNeeded
} from '../pilot-assignment/helpers/PilotAssignmentHelpers';
import PilotAssignmentService from '../pilot-assignment/services/PilotAssignmentService';
import { ArrowElbowDownRight, Download, Eye, Lock, Upload } from 'phosphor-react-sc';
import { LetterIcon } from '../../../components/layout/icons/LetterIcon';
import { MiniCardList } from '../../../components/layout/card/MiniCard';

export const PilotagePilotCardBody = ({ pilotagePilot }) => {
    const pilotage = pilotagePilot.pilotage;
    const assignmentService = new PilotAssignmentService(pilotagePilot);
    return (
        <div className="pp-card">
            <div className="pp-card-body-locations">
                <div>
                    <div className="text-truncate">
                        {parse(pilotage.fromLocation.name)}
                    </div>
                    <div>
                        {pilotage.pilotageNo}
                    </div>
                </div>
                <div>
                    <div>
                        <ArrowElbowDownRight weight="duotone" size={20}/>
                    </div>
                    <div className="text-truncate">
                        &nbsp;{parse(pilotage.toLocation.name)}
                    </div>
                </div>
            </div>
            <Spacer height={10} />
            <div className="pp-card-body-info">
                <div>
                    {
                        showPilots() &&
                        <Pilots pilotagePilots={pilotagePilot.pilotage.pilotagePilotsInformation} />
                    }

                </div>
                <div>
                    {
                        pilotagePilot.isTrainee && <LetterIcon letter="L" type="trainee" />
                    }
                    {
                        showLocked() && <PilotageIcon><Lock size={32} weight="duotone" /></PilotageIcon>
                    }
                    {
                        hasExemptionApplication() && <PilotageIcon><ExemptionStatusIcon status={pilotagePilot.pilotage.pilotageExemptionApplicationStatus} /></PilotageIcon>
                    }
                    {
                        pilotagePilot.isExaminer && <LetterIcon letter="S" type="examiner" />
                    }
                    {
                        pilotagePilot.pilotage.hasObservation && <PilotageIcon><Eye size={32} weight="duotone" /></PilotageIcon>
                    }
                    {
                        pilotagePilot.pilotage.isTowing && <PilotageIcon><Icons iconName="towing" color={IconColors.Primary} /></PilotageIcon>
                    }
                    {
                        pilotagePilot.pilotage.isHelicopterRequired && <PilotageIcon><Icons iconName="helicopter" color={IconColors.Primary} /> </PilotageIcon>
                    }
                    {
                        pilotagePilot.hasExternalChanges && <PilotageIcon><Download size={32} weight="duotone" color="var(--pp-external-changes-font)" /></PilotageIcon>
                    }
                    {
                        showExam() && <PilotageIcon><Icons iconName="exam" /> </PilotageIcon>
                    }
                    {
                        assignmentService.isDirty && <PilotageIcon><Upload size={32} weight="duotone" color="var(--pp-local-changes-font)" /></PilotageIcon>
                    }
                </div>
            </div>
            {
                showReplyRequest() && <div className="pp-reply"><span className="reply-link">{getReplyRequestText()}</span></div>
            }
        </div>
    );

    function showReplyRequest() {
        return isPilotAssignmentAssignedAndNotProcessed(pilotagePilot) || isPilotAssignmentCorrectionNeeded(pilotagePilot);
    }

    function getReplyRequestText() {
        if (isPilotAssignmentAssignedAndNotProcessed(pilotagePilot)) return parse("Besvar foresp&oslash;rsel");

        return "Korriger skipperbevis";
    }

    function showLocked() {
        return !isPilotAssignmentCompleted(pilotagePilot) && pilotagePilot.pilotage.pilotageDetail.isLocked;
    }

    function hasExemptionApplication() {
        return !isObjectNull(pilotagePilot.pilotage.pilotageExemptionApplicationStatus);
    }

    function showPilots() {
        if (showReplyRequest()) return false;
        if (isArrayEmpty(pilotagePilot.pilotage.pilotagePilotsInformation)) return false;

        return pilotagePilot.pilotage.pilotagePilotsInformation.length > 1;
    }

    function showExam() {
        return !isArrayEmpty(pilotage.pecExams);
    }
}

export const PilotageCardBody = ({ pilotage }) => {
    return (
        <>
            <div>
                {parse(pilotage.fromLocation.name)}
            </div>
            <div className="current-pilotage-to-location">
                <div>
                    <Icons iconName="arrowTo" dimensions={20} color={IconColors.Secondary} />
                </div>
                <div>
                    &nbsp;{parse(pilotage.toLocation.name)}
                </div>
            </div>
            <Spacer height={10} />
                <div>
                    <Pilots pilotagePilots={pilotage.pilotagePilotsInformation} />
                </div>
                <div className="current-pilotage-icons">
                    {pilotage.hasHazmat && <SvgIcon iconName="hazmat" dimensions={32} />}
                    {pilotage.hasObservation && <SvgIcon iconName="eye" dimensions={32} color={IconColors.Secondary} />}
                    {pilotage.isTowing && <SvgIcon iconName="towing" dimensions={32} color={IconColors.Secondary} />}
                    {pilotage.pilotageDetail.isLocked && <SvgIcon iconName="lock" color={IconColors.Secondary} dimensions={32} />}
                    <ExemptionStatusIcon status={pilotage.pilotageExemptionApplicationStatus} />
                </div>
        </>
    )
}

const ExemptionStatusIcon = ({ status }) => {
    switch (status?.systemName) {
        case PilotageExemptionApplicationStatusEnum.APPLIED: {
            return <SvgIcon iconName="exemptionNotSent" dimensions={30} color={PilotageExemptionApplicationStatusColors.APPLIED} />
        }
        case PilotageExemptionApplicationStatusEnum.CONSIDERED_EVIDENTLY_JUSTIFIABLE: {
            return <SvgIcon iconName="exemptionPending" dimensions={30} color={PilotageExemptionApplicationStatusColors.CONSIDERED_EVIDENTLY_JUSTIFIABLE} />
        }
        case PilotageExemptionApplicationStatusEnum.CONSIDERED_NOT_EVIDENTLY_JUSTIFIABLE: {
            return <SvgIcon iconName="exemptionPending" dimensions={30} color={PilotageExemptionApplicationStatusColors.CONSIDERED_NOT_EVIDENTLY_JUSTIFIABLE} />
        }
        case PilotageExemptionApplicationStatusEnum.DISMISSED: {
            return <SvgIcon iconName="exemptionRejected" dimensions={30} color={PilotageExemptionApplicationStatusColors.DISMISSED} />
        }
        case PilotageExemptionApplicationStatusEnum.GRANTED: {
            return <SvgIcon iconName="exemptionGranted" dimensions={30} color={PilotageExemptionApplicationStatusColors.GRANTED} />
        }
        case PilotageExemptionApplicationStatusEnum.REJECTED: {
            return <SvgIcon iconName="exemptionRejected" dimensions={30} color={PilotageExemptionApplicationStatusColors.REJECTED} />
        }
        case PilotageExemptionApplicationStatusEnum.SENT_TO_PILOT_MASTER: {
            return <SvgIcon iconName="exemptionPending" dimensions={30} color={PilotageExemptionApplicationStatusColors.SENT_TO_PILOT_MASTER} />
        }
        case PilotageExemptionApplicationStatusEnum.VOYAGE_ENDED: {
            return <SvgIcon iconName="exemptionRejected" dimensions={30} color={PilotageExemptionApplicationStatusColors.VOYAGE_ENDED} />
        }
        default: return "";
    }
}

const Pilots = ({ pilotagePilots }) => {
    return (
        (!isArrayEmpty(pilotagePilots)) &&
        <MiniCardList items={createPilotAssignmentPilotsShortList(pilotagePilots)} />
    )
};

const PilotageIcon = ({children}) => {
    return (
        <div className="k-d-grid k-align-items-stretch k-justify-content-center">{children}</div>
    )
}
